/* PDP Variant Label — SOLO variante selezionata, niente fallback
   Fix: non toccare i prodotti con UNA sola variante e non cancellare la label se l'ID non è risolvibile.
*/
(function () {
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function parseJSON(id, fallback) {
    try { var el = document.getElementById(id); return el ? JSON.parse(el.textContent || 'null') : fallback; }
    catch (e) { return fallback; }
  }

  // Varianti e mappe
  var VARIANTS = parseJSON('pdp-variants-json', []);
  var BY_ID = {};
  VARIANTS.forEach(function (v) { BY_ID[String(v.id)] = v; });
  var SINGLE_VARIANT = VARIANTS.length <= 1;

  // Tag prodotto (per "no-label" in PDP) – opzionale
  var PRODUCT_TAGS = parseJSON('pdp-product-tags-json', []);
  var hasNoLabel = false;
  if (Array.isArray(PRODUCT_TAGS)) {
    var tagsLC = PRODUCT_TAGS.join(',').toLowerCase();
    hasNoLabel = tagsLC.includes('no-label') || tagsLC.includes('no label') || tagsLC.includes('no_label');
  }

  // Variante iniziale (server)
  var INITIAL_VARIANT_ID = String(parseJSON('pdp-initial-variant-id', '') || '');

  function roundPct(compareAt, price) {
    if (!compareAt || compareAt <= price) return 0;
    var diff = compareAt - price;
    var pctX100 = (diff * 10000) / compareAt; // percentuale * 100
    var pInt = Math.floor(pctX100 / 100);
    var pDec = Math.floor(pctX100 % 100);
    return (pDec > 50) ? (pInt + 1) : pInt; // <=0,50 giù; >0,50 su
  }

  function getCurrentVariantId() {
    // 0) ?variant in URL
    var idFromUrl = new URLSearchParams(location.search).get('variant');
    if (idFromUrl) return String(idFromUrl);

    // 1) Radio/Select con name="id"
    var checkedRadio = $('input[name="id"]:checked');
    if (checkedRadio && checkedRadio.value) return String(checkedRadio.value);

    var selectId = $('select[name="id"]');
    if (selectId && selectId.value) return String(selectId.value);

    // 2) Hidden input nel form
    var hiddenId = $('form [name="id"]');
    if (hiddenId && hiddenId.value) return String(hiddenId.value);

    // 3) Variante iniziale dal server
    if (INITIAL_VARIANT_ID) return INITIAL_VARIANT_ID;

    // 4) Fallback: prima variante
    return String((VARIANTS[0] || {}).id || '');
  }

  function renderForVariant(variant) {
    var slots = $$('.pdp-label-slot');
    var labels = $$('.js-pdp-label');
    if (!slots.length || !labels.length) return;

    var show = false, text = '', bg = '';

    if (variant && variant.hasOwnProperty('available') && !variant.available) {
      text = 'Esaurito';
      bg = '#B30300';
      show = true;
    } else if (variant) {
      var pct = roundPct(variant.compare_at_price, variant.price);
      if (pct > 0 && !hasNoLabel) {
        text = '-' + pct + '%';
        bg = '#004d9d';
        show = true;
      }
    }

    // Applica SOLO se c'è qualcosa da mostrare; altrimenti non cancelliamo il render server-side
    if (show) {
      slots.forEach(function (slot) { slot.style.display = 'block'; });
      labels.forEach(function (el) {
        el.textContent = text;
        el.style.backgroundColor = bg;
        el.style.color = '#fff';
        el.style.display = 'block';
        el.style.width = '100%';
        el.style.padding = '4px 0';
        el.style.textAlign = 'center';
        el.style.fontFamily = "'Work Sans',system-ui,-apple-system,'Segoe UI',Roboto,Helvetica,Arial,'Apple Color Emoji','Segoe UI Emoji'";
        el.style.fontWeight = '700';
        el.style.fontSize = '15px';
        el.style.lineHeight = '1';
      });
    }
  }

  function updateLabel() {
    var id = getCurrentVariantId();
    // Se non risolviamo l'ID, NON tocchiamo nulla (manteniamo la label server-side)
    if (!id) return;
    var variant = BY_ID[String(id)];
    if (!variant) return; // idem, non toccare

    renderForVariant(variant);
  }

  function bind() {
    // Se è un prodotto con UNA sola variante, lasciamo il render server-side e non tocchiamo nulla
    if (SINGLE_VARIANT) return;

    // Cambi su input/select
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.name === 'id' || t.closest('variant-radios') || t.closest('variant-selects')) {
        setTimeout(updateLabel, 0);
      }
    });

    // Eventi custom (Dawn e simili)
    document.addEventListener('variant:change', function (ev) {
      var v = ev && ev.detail && (ev.detail.variant || ev.detail.currentVariant || ev.detail.selectedVariant);
      if (v && v.id != null) {
        BY_ID[String(v.id)] = v; // assicura coerenza
        renderForVariant(v);
      } else {
        setTimeout(updateLabel, 0);
      }
    });

    // Osserva l’input name="id" se cambia via JS
    var idInput = $('form [name="id"]');
    if (idInput) {
      var mo = new MutationObserver(function () { setTimeout(updateLabel, 0); });
      mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    // Primo render dinamico solo per prodotti multi-variante
    updateLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
